import { useState, useEffect } from 'react';
import * as api from '../lib/api';

// Module-level cache so every component sharing the picker/renderer only
// triggers one network request, no matter how many post cards mount.
let cache = null;
let inflight = null;

export function useIslamojis() {
  const [islamojis, setIslamojis] = useState(cache || []);

  useEffect(() => {
    if (cache) return;
    if (!inflight) {
      inflight = api.getIslamojis()
        .then(r => { cache = r.data || []; return cache; })
        .catch(() => { cache = []; return cache; });
    }
    let cancelled = false;
    inflight.then(data => { if (!cancelled) setIslamojis(data); });
    return () => { cancelled = true; };
  }, []);

  return islamojis;
}
